import React, { useEffect } from "react";
import { FormikProvider, useFormik, Field, Form, ErrorMessage } from "formik";
import * as jnb from "react-bootstrap";
import * as Yup from "yup";
import { useState } from "react";
import { config } from "../CommonUtils/CommonURLS";
import { CommonAxiosGet, CommonAxiosPost } from "../CommonUtils/CommonAxios";
import Swal from "sweetalert2";
import Select from "react-select";
const ChangeOfLocationDtls = (paymentDone, goNext) => {
  if (paymentDone?.paymentDone === true) {
    console.log("Payment completed");
  } else {
    console.log("Payment not done");
  }



  const clg = sessionStorage?.getItem("LOGIN");
  const isDegree = clg === "degree";

  const [districtData, setDistrictData] = useState([]);
  const [mandalData, setMandalData] = useState([]);
  const [constituencyData, setConstituencyData] = useState([]);
  const [secretariatData, setSecretariatData] = useState([]);
  const [villageData, setVillageData] = useState([]);
  const [locationData, setLocationData] = useState(null);
  const [clgdata, setClgdata] = useState([]);

  const initialValues = {
    completeAddress: "",
    districtNew: "",
    mandalNew: "",
    pinCodeNew: "",
    rationaleJustification: "",
    constituency: "",
    village: "",
    secretariat: "",

    shiftType: "",
    leaseFromDate: "",
    leaseToDate: "",
    lease30Years: "",

    isPermanentRCC: "",
    isDistance500m: "",
    distanceFromExisting: "",
  };

  const validationSchema = Yup.object({
    completeAddress: Yup.string().required("Required"),
    districtNew: Yup.string().required("Required"),
    mandalNew: Yup.string().required("Required"),
    pinCodeNew: Yup.string()
      .matches(/^[0-9]{6}$/, "Must be exactly 6 digits")
      .required("Required"),
    rationaleJustification: Yup.string().required("Required"),
    constituency: Yup.string().required("Required"),
    village: Yup.string().required("Required"),
    secretariat: Yup.string().required("Required"),

    // Shift Type
    shiftType: isDegree ? Yup.string().required("Required") : Yup.string(),

    // Lease fields (conditional)
    leaseFromDate: Yup.string().when("shiftType", {
      is: "Leased to Leased",
      then: () => (isDegree ? Yup.string().required("Required") : Yup.string()),
    }),
    leaseToDate: Yup.string().when("shiftType", {
      is: "Leased to Leased",
      then: () => (isDegree ? Yup.string().required("Required") : Yup.string()),
    }),
    lease30Years: Yup.string().when("shiftType", {
      is: "Leased to Leased",
      then: () => (isDegree ? Yup.string().required("Required") : Yup.string()),
    }),
    // Degree-only fields
    isPermanentRCC: isDegree ? Yup.string().required("Required") : Yup.string(),
    isDistance500m: isDegree ? Yup.string().required("Required") : Yup.string(),
    distanceFromExisting: isDegree
      ? Yup.number()
        .typeError("Must be a number")
        .required("Required")
        .min(0, "Cannot be negative")
      : Yup.number(),
  });

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: (values) => {
      Swal.fire({
        title: "Are you sure?",
        text: "Do you want to submit the details?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, submit it!",
        cancelButtonText: "No, cancel",
      }).then((result) => {
        if (result.isConfirmed) {
          // Common payload
          let payload = {
            addressOfnewLocation: values.completeAddress,
            newDistrict: parseInt(values.districtNew),
            newMandal: parseInt(values.mandalNew),
            newPincode: parseInt(values.pinCodeNew),
            justification: values.rationaleJustification,
            secretariatCode: parseInt(values.secretariat),
            villageCode: parseInt(values.village),
            constituencyCode: parseInt(values.constituency),
          };
          let url;
          if (clg === "degree") {
            url = `${config.url.FAC_URL}saveShiftingOfInstDetails`;
            // Append degree-only fields
            payload = {
              ...payload,
              shiftType: values.shiftType,
              leaseFromDate: values.leaseFromDate,
              leaseToDate: values.leaseToDate,
              thirtyYearsLease: values.lease30Years,
              isPermanentRCC: values.isPermanentRCC,
              isDistance500m: values.isDistance500m,
              distanceFromExisting: values.distanceFromExisting,
            };
          } else {
            url = `${config.url.FAC_URL}saveLocationDetails`;
          }
          CommonAxiosPost(url, payload)
            .then((res) => {
              if (
                res?.data?.scode === "01" ||
                res?.data?.ResponseCode === "01"
              ) {
                Swal.fire({
                  title:
                    res.data.sdesc ||
                    res.data.ResponseDesc ||
                    "Location Details Updated!",
                  icon: "success",
                  backdrop: false,
                  confirmButtonText: "OK",
                }).then((successResult) => {
                  if (successResult.isConfirmed) {
                    GetLocationDetails();
                    goNext();
                  }
                });
              } else {
                Swal.fire({
                  text:
                    res.data?.sdesc ||
                    res.data?.ResponseDesc ||
                    "Failed to update location",
                  icon: "warning",
                });
              }
            })
            .catch((err) => {
              console.error("Submission Error:", err);
              Swal.fire({
                text: "Something went wrong while submitting the location change!",
                icon: "error",
              });
            });
        }
      });
    },
  });
  const { values, setFieldValue, handleSubmit } = formik;
  // GET API ----> existed colleges data
  function GetCollegeData() {
    const url = `${config.url.FAC_URL}getInstitutionPolyDetails`;
    CommonAxiosGet(url)
      .then((res) => {
        if (res?.data?.status === true || res?.data?.scode === "01") {
          setClgdata(res?.data?.data);
        } else {
          formik.resetForm();
        }
      })
      .catch((err) => {
        console.error("Error fetching college data:", err);
      });
  }
  // GET API ----> districts data
  function GetDistrictsData() {
    let Url = `${config.url.FAC_URL}getdistricts`;
    CommonAxiosGet(Url).then((res) => {
      if (res.data.status === true) {
        setDistrictData(res?.data?.districtmst);
      } else {
        setDistrictData([]);
      }
    });
  }
  // GET API ----> mandals data by District Code
  function GetMandalData(distCode) {
    if (!distCode) {
      setMandalData([]);
      return;
    }
    let Url = `${config.url.FAC_URL}getmandals/${distCode}`;
    CommonAxiosGet(Url)
      .then((res) => {
        if (res.data.status === true) {
          const data = res.data.mandalmst;
          setMandalData(data);
        } else {
          setMandalData([]);
        }
      })
      .catch((err) => {
        console.error("Error fetching mandals:", err);
        setMandalData([]);
      });
  }
  function GetConstituencyData(distCode) {
    if (!distCode) {
      setConstituencyData([]);
      return;
    }
    let Url = `${config.url.FAC_URL}getConstituencyList`;
    CommonAxiosGet(Url)
      .then((res) => {
        if (res.data.status === true) {
          const data = res.data.list;
          setConstituencyData(data);
        } else {
          setConstituencyData([]);
        }
      })
      .catch((err) => {
        console.error("Error fetching constituency:", err);
        setConstituencyData([]);
      });
  }
  // GET API ----> Village data by District and Mand Code
  function GetVillageData(distCode, mandalCode) {
    if (!distCode || !mandalCode) {
      setVillageData([]);
      return;
    }
    let Url = `${config.url.FAC_URL}getvillages/${distCode}/${mandalCode}`;
    CommonAxiosGet(Url)
      .then((res) => {
        if (res.data.status === true) {
          const data = res.data.villagemst;
          setVillageData(data);
        } else {
          setVillageData([]);
        }
      })
      .catch((err) => {
        console.error("Error fetching constituency:", err);
        setVillageData([]);
      });
  }
  // GET API ----> Secretariat data by District and Mand Code
  function GetSecretariatData(distCode) {
    if (!distCode) {
      setSecretariatData([]);
      return;
    }
    let Url = `${config.url.FAC_URL}getSecraterietList?distcode=${distCode}`;
    CommonAxiosGet(Url)
      .then((res) => {
        if (res.data.status === true) {
          const data = res.data.list;
          setSecretariatData(data);
        } else {
          setSecretariatData([]);
        }
      })
      .catch((err) => {
        console.error("Error fetching secretariat:", err);
        setSecretariatData([]);
      });
  }
  // GET API ----> Location Data
  function GetLocationDetails() {
    let Url;
    if (clg === "degree") {
      Url = `${config.url.FAC_URL}getShiftingOfInstDetails`;
    } else {
      Url = `${config.url.FAC_URL}getLocationDetails`;
    }
    CommonAxiosGet(Url)
      .then((res) => {
        if (res.data.status === true && res?.data?.data?.length > 0) {
          const locData = res?.data?.data[0];
          setLocationData(locData);
          formik.setFieldValue("districtNew", locData?.new_district || "");
          GetMandalData(locData?.new_district);

          formik.setFieldValue("mandalNew", locData?.new_mandal || "");
          GetVillageData(locData?.new_district, locData?.new_mandal);
          formik.setFieldValue("village", locData?.village_code || "");

          GetSecretariatData(locData?.new_district);
          formik.setFieldValue("secretariat", locData?.secretariat_code || "");
          GetConstituencyData(locData?.new_district);
          formik.setFieldValue("constituency", locData?.constituency_code || "");


          formik.setFieldValue("pinCodeNew", locData?.new_pincode || "");
          formik.setFieldValue("completeAddress", locData?.address_ofnew_location || "");
          formik.setFieldValue("rationaleJustification", locData?.justification || "");
          if (clg === "degree") {
            formik.setFieldValue("shiftType", locData?.shift_type || "");
            formik.setFieldValue("leaseFromDate", locData?.lease_from_date || "");
            formik.setFieldValue("leaseToDate", locData?.lease_to_date || "");
            formik.setFieldValue("lease30Years", locData?.thirty_years_lease || "");
            formik.setFieldValue("isPermanentRCC", locData?.is_permanent_rcc || "");
            formik.setFieldValue("isDistance500m", locData?.is_distance_500m || "");
            formik.setFieldValue("distanceFromExisting", locData.distance_from_existing || "");
          }
          /* Dependent Dropdown Calls */

          // GetConstituencyData(locData.new_district);
        }
      })
      .catch((err) => {
        console.error("API Fetch Error:", err);
      });
  }


  useEffect(() => {
    GetDistrictsData();
    GetCollegeData();
    GetLocationDetails();
  }, []);

  // useEffect(() => {
  //   if (locationData && constituencyData.length > 0) {
  //     const constItem = constituencyData.find(
  //       (item) => item.constituency_code === locationData.constituency_code,
  //     );
  //     if (constItem) {
  //       formik.setFieldValue("constituency", constItem.constituency_code);
  //       GetSecretariatData(locationData.new_district);
  //     }
  //   }
  // }, [constituencyData]);

  useEffect(() => {
    if (locationData && secretariatData.length > 0) {
      const constItem = secretariatData.find(
        (item) => item.secretariat_code === locationData.secretariat_code,
      );
      if (constItem) {
        formik.setFieldValue("secretariat", constItem.secretariat_code);
      }
    }
  }, [secretariatData]);
  return (
    <jnb.Container fluid className="py-3">
      <FormikProvider value={formik}>
        <Form onSubmit={handleSubmit}>
          <jnb.Card className="shadow-sm border-0 mt-4">
            <jnb.Card.Body>
              {clg === "degree" && (
                <>
                  <h5 className="mb-3 innerheader-new">
                    <span>Existing Institution Details</span>
                  </h5>

                  {clgdata?.length > 0 ? (
                    <jnb.Card.Body
                      style={{ backgroundColor: "#f0effc" }}
                      className="mb-3"
                    >
                      {/* Row 1 */}
                      <jnb.Row className="mb-3">
                        <jnb.Col md={6}>
                          <div className="d-flex">
                            <div
                              className="fw-bold text-secondary me-2"
                              style={{ minWidth: "160px" }}
                            >
                              University Name :
                            </div>

                            <div className="text-dark">
                              {clgdata[0]?.ub_name || "-"}
                            </div>
                          </div>
                        </jnb.Col>

                        <jnb.Col md={6}>
                          <div className="d-flex">
                            <div
                              className="fw-bold text-secondary me-2"
                              style={{ minWidth: "160px" }}
                            >
                              Institution Name :
                            </div>

                            <div className="text-dark">
                              {clgdata[0]?.inst_name || "-"}
                            </div>
                          </div>
                        </jnb.Col>
                      </jnb.Row>

                      {/* Row 2 */}
                      <jnb.Row className="mb-3">
                        <jnb.Col md={6}>
                          <div className="d-flex">
                            <div
                              className="fw-bold text-secondary me-2"
                              style={{ minWidth: "160px" }}
                            >
                              Institution Code :
                            </div>

                            <div className="text-dark">
                              {clgdata[0]?.coll_code || "-"}
                            </div>
                          </div>
                        </jnb.Col>

                        <jnb.Col md={6}>
                          <div className="d-flex">
                            <div
                              className="fw-bold text-secondary me-2"
                              style={{ minWidth: "160px" }}
                            >
                              Place / Town :
                            </div>

                            <div className="text-dark">
                              {clgdata[0]?.place_town || "-"}
                            </div>
                          </div>
                        </jnb.Col>
                      </jnb.Row>

                      {/* Row 3 */}
                      <jnb.Row className="mb-3">
                        <jnb.Col md={6}>
                          <div className="d-flex">
                            <div
                              className="fw-bold text-secondary me-2"
                              style={{ minWidth: "160px" }}
                            >
                              District :
                            </div>

                            <div className="text-dark">
                              {clgdata[0]?.dist_name || "-"}
                            </div>
                          </div>
                        </jnb.Col>

                        <jnb.Col md={6}>
                          <div className="d-flex">
                            <div
                              className="fw-bold text-secondary me-2"
                              style={{ minWidth: "160px" }}
                            >
                              Mandal :
                            </div>

                            <div className="text-dark">
                              {clgdata[0]?.mandal_name || "-"}
                            </div>
                          </div>
                        </jnb.Col>
                      </jnb.Row>

                      {/* Row 4 */}
                      <jnb.Row className="mb-3">
                        <jnb.Col md={6}>
                          <div className="d-flex">
                            <div
                              className="fw-bold text-secondary me-2"
                              style={{ minWidth: "160px" }}
                            >
                              Pincode :
                            </div>

                            <div className="text-dark">
                              {clgdata[0]?.pincode || "-"}
                            </div>
                          </div>
                        </jnb.Col>

                        <jnb.Col md={6}>
                          <div className="d-flex">
                            <div
                              className="fw-bold text-secondary me-2"
                              style={{ minWidth: "160px" }}
                            >
                              Institution Address :
                            </div>

                            <div className="text-dark">
                              {clgdata[0]?.inst_address || "-"}
                            </div>
                          </div>
                        </jnb.Col>
                      </jnb.Row>
                    </jnb.Card.Body>
                  ) : (
                    <center className="text-danger mt-4 h5">
                      ***** No Data Found *****
                    </center>
                  )}
                </>
              )}

              <h5 className="mb-3 innerheader-new">
                <span>Shifting of the Institution</span>
              </h5>
              {clg === "degree" && (
                <>
                  <jnb.Row className="mt-3">
                    <jnb.Col xs={12} sm={6} md={6} lg={4} xl={4} xxl={4}>
                      <jnb.Form.Label className="small fw-bold text-dark">
                        Type of Shifting<span className="text-danger">*</span>
                      </jnb.Form.Label>
                      <Field
                        name="shiftType"
                        as="select"
                        className="form-control form-control-sm"
                      //disabled={locationData !== null}
                      >
                        <option value="">-- Select Shift Type --</option>
                        <option value="Leased to Leased">
                          From Leased to Leased Building
                        </option>
                        <option value="Leased to Own">
                          From Leased to Own Building
                        </option>
                      </Field>
                      <ErrorMessage
                        name="shiftType"
                        component="div"
                        className="text-danger extra-small"
                      />
                    </jnb.Col>
                  </jnb.Row>

                  <jnb.Row className="mt-3">
                    {values.shiftType === "Leased to Leased" && (
                      <>
                        <jnb.Col
                          xs={12}
                          sm={6}
                          md={6}
                          lg={4}
                          xl={4}
                          xxl={4}
                          className="d-flex flex-column"
                        >
                          <jnb.Form.Label className="small fw-bold text-dark">
                            Validity of the Lease Period of New Building From
                            Date
                            <span className="text-danger">*</span>
                          </jnb.Form.Label>

                          <Field
                            name="leaseFromDate"
                            type="date"
                            className="form-control form-control-sm mb-2"
                            placeholder="From Date"
                            //disabled={locationData !== null}
                            max={new Date().toISOString().split("T")[0]}
                          />
                          <ErrorMessage
                            name="leaseFromDate"
                            component="div"
                            className="text-danger extra-small mb-2"
                          />
                        </jnb.Col>
                        <jnb.Col
                          xs={12}
                          sm={6}
                          md={6}
                          lg={4}
                          xl={4}
                          xxl={4}
                          className="d-flex flex-column"
                        >
                          <jnb.Form.Label className="small fw-bold text-dark">
                            Validity of the Lease Period of New Building To Date
                            <span className="text-danger">*</span>
                          </jnb.Form.Label>

                          <Field
                            name="leaseToDate"
                            type="date"
                            className="form-control form-control-sm"
                            placeholder="To Date"
                            //disabled={locationData !== null}
                            min={values.leaseFromDate || ""}
                          />
                          <ErrorMessage
                            name="leaseToDate"
                            component="div"
                            className="text-danger extra-small"
                          />
                        </jnb.Col>

                        <jnb.Col
                          xs={12}
                          sm={6}
                          md={6}
                          lg={4}
                          xl={4}
                          xxl={4}
                          className="d-flex flex-column"
                        >
                          <jnb.Form.Label className="small fw-bold text-dark">
                            Whether the College Possess 30 Years of Lease for
                            New Building
                            <span className="text-danger">*</span>
                          </jnb.Form.Label>

                          <div
                            role="group"
                            aria-labelledby="lease30Years"
                            className="d-flex gap-3 mt-1"
                          >
                            <label className="form-check-label">
                              <Field
                                type="radio"
                                name="lease30Years"
                                value="Yes"
                                className="form-check-input me-1"
                              //disabled={locationData !== null}
                              />
                              Yes
                            </label>

                            <label className="form-check-label">
                              <Field
                                type="radio"
                                name="lease30Years"
                                value="No"
                                className="form-check-input me-1"
                              //disabled={locationData !== null}
                              />
                              No
                            </label>
                          </div>

                          <ErrorMessage
                            name="lease30Years"
                            component="div"
                            className="text-danger extra-small"
                          />
                        </jnb.Col>
                      </>
                    )}
                  </jnb.Row>
                </>
              )}

              <jnb.Row className="mt-3">
                <jnb.Col xs={12} sm={6} md={6} lg={4} xl={4} xxl={4}>
                  <jnb.Form.Label className="small fw-bold text-dark">
                    District (New) <span className="text-danger">*</span>
                  </jnb.Form.Label>
                  <Field
                    name="districtNew"
                    as="select"
                    className="form-control form-control-sm"
                    // //disabled={locationData !== null}
                    onChange={(e) => {
                      const selectedDist = e.target.value;
                      setFieldValue("districtNew", selectedDist);
                      GetMandalData(selectedDist);
                      GetConstituencyData(selectedDist);
                      GetSecretariatData(selectedDist);
                      formik.setFieldValue("mandalNew", "");
                      formik.setFieldValue("constituency", "");
                      formik.setFieldValue("village", "");
                      formik.setFieldValue("secretariat", "");
                    }}
                  >
                    <option value="">-- Select District --</option>
                    {districtData && districtData.length > 0 ? (
                      districtData.map((item, index) => (
                        <option key={index} value={item.dist_code}>
                          {item.dist_name}
                        </option>
                      ))
                    ) : (
                      <option disabled>Loading districts...</option>
                    )}
                  </Field>
                  <ErrorMessage
                    name="districtNew"
                    component="div"
                    className="text-danger extra-small"
                  />
                </jnb.Col>

                <jnb.Col xs={12} sm={6} md={6} lg={4} xl={4} xxl={4}>
                  <jnb.Form.Label className="small fw-bold text-dark">
                    Constituency<span className="text-danger">*</span>
                  </jnb.Form.Label>

                  <Select
                    name="constituency"
                    is//disabled={locationData !== null}
                    options={
                      constituencyData?.map((item) => ({
                        value: item.constituency_code,
                        label: item.constituency_name,
                      })) || []
                    }
                    value={
                      constituencyData
                        ?.map((item) => ({
                          value: item.constituency_code,
                          label: item.constituency_name,
                        }))
                        .find(
                          (option) => option.value === values.constituency,
                        ) || null
                    }
                    onChange={(selectedOption) => {
                      const constCode = selectedOption
                        ? selectedOption.value
                        : "";
                      setFieldValue("constituency", constCode);
                    }}
                    placeholder={
                      values.districtNew
                        ? "-- Select Constituency --"
                        : "Select District First"
                    }
                    isSearchable
                    classNamePrefix="react-select"
                  />

                  <ErrorMessage
                    name="constituency"
                    component="div"
                    className="text-danger extra-small"
                  />
                </jnb.Col>

                <jnb.Col xs={12} sm={6} md={6} lg={4} xl={4} xxl={4}>
                  <jnb.Form.Label className="small fw-bold text-dark">
                    Mandal (New) <span className="text-danger">*</span>
                  </jnb.Form.Label>
                  <Field
                    name="mandalNew"
                    as="select"
                    className="form-control form-control-sm"
                    //disabled={locationData !== null}
                    onChange={(e) => {
                      const selectedMandal = e.target.value;
                      setFieldValue("mandalNew", selectedMandal);
                      GetVillageData(
                        formik?.values?.districtNew,
                        selectedMandal,
                      );
                      formik.setFieldValue("village", "");
                    }}
                  >
                    <option value="">-- Select Mandal --</option>
                    {mandalData && mandalData.length > 0 ? (
                      mandalData.map((item, index) => (
                        <option key={index} value={item.mandal_code}>
                          {item.mandal_name}
                        </option>
                      ))
                    ) : (
                      <option value="" disabled>
                        {values.districtNew
                          ? "Loading Mandals..."
                          : "Select District First"}
                      </option>
                    )}
                  </Field>

                  <ErrorMessage
                    name="mandalNew"
                    component="div"
                    className="text-danger extra-small"
                  />
                </jnb.Col>

                <jnb.Col xs={12} sm={6} md={6} lg={4} xl={4} xxl={4}>
                  <jnb.Form.Label className="small fw-bold text-dark">
                    Village <span className="text-danger">*</span>
                  </jnb.Form.Label>
                  <Field
                    name="village"
                    as="select"
                    className="form-control form-control-sm"
                  //disabled={locationData !== null}
                  >
                    <option value="">-- Select Village --</option>
                    {villageData && villageData.length > 0 ? (
                      villageData.map((item, index) => (
                        <option key={index} value={item.village_code}>
                          {item.village_name}
                        </option>
                      ))
                    ) : (
                      <option value="" disabled>
                        {values.mandalNew
                          ? "Loading Village..."
                          : "Select Mandal First"}
                      </option>
                    )}
                  </Field>
                  <ErrorMessage
                    name="village"
                    component="div"
                    className="text-danger extra-small"
                  />
                </jnb.Col>

                <jnb.Col xs={12} sm={6} md={6} lg={4} xl={4} xxl={4}>
                  <jnb.Form.Label className="small fw-bold text-dark">
                    Secretariat <span className="text-danger">*</span>
                  </jnb.Form.Label>

                  <Select
                    name="secretariat"
                    is//disabled={locationData !== null}
                    options={
                      secretariatData?.map((item) => ({
                        value: item.secretariat_code,
                        label: item.secretariat_name,
                      })) || []
                    }
                    value={
                      secretariatData
                        ?.map((item) => ({
                          value: item.secretariat_code,
                          label: item.secretariat_name,
                        }))
                        .find(
                          (option) => option.value === values.secretariat,
                        ) || null
                    }
                    onChange={(selectedOption) => {
                      setFieldValue(
                        "secretariat",
                        selectedOption ? selectedOption.value : "",
                      );
                    }}
                    placeholder={
                      values.mandalNew
                        ? "-- Select Secretariat --"
                        : "Select Mandal First"
                    }
                    isSearchable
                    classNamePrefix="react-select"
                  />

                  <ErrorMessage
                    name="secretariat"
                    component="div"
                    className="text-danger extra-small"
                  />
                </jnb.Col>

                <jnb.Col xs={12} sm={6} md={6} lg={4} xl={4} xxl={4}>
                  <jnb.Form.Label className="small fw-bold text-dark">
                    PIN Code (New) <span className="text-danger">*</span>
                  </jnb.Form.Label>
                  <Field
                    name="pinCodeNew"
                    className="form-control form-control-sm"
                    placeholder="6-digit PIN"
                    maxLength={6}
                  //disabled={locationData !== null}
                  />
                  <ErrorMessage
                    name="pinCodeNew"
                    component="div"
                    className="text-danger extra-small"
                  />
                </jnb.Col>
              </jnb.Row>

              <jnb.Row className="mt-3">
                <jnb.Col xs={12} sm={12} md={6} lg={6} xl={6} xxl={6}>
                  <jnb.Form.Group className="mb-3">
                    <jnb.Form.Label className="small fw-bold text-dark">
                      Complete Address of New Location{" "}
                      <span className="text-danger">*</span>
                    </jnb.Form.Label>

                    <Field
                      as="textarea"
                      name="completeAddress"
                      rows={4}
                      className="form-control"
                      //disabled={locationData !== null}
                      style={{
                        width: "100%",
                        resize: "vertical",
                        minHeight: "100px",
                      }}
                    />
                    <ErrorMessage
                      name="completeAddress"
                      component="div"
                      className="text-danger extra-small mt-1"
                    />
                  </jnb.Form.Group>
                </jnb.Col>

                <jnb.Col xs={12} sm={12} md={6} lg={6} xl={6} xxl={6}>
                  <jnb.Form.Group className="mb-3">
                    <jnb.Form.Label className="small fw-bold text-dark">
                      Rationale / Justification{" "}
                      <span className="text-danger">*</span>
                    </jnb.Form.Label>
                    <Field
                      as="textarea"
                      name="rationaleJustification"
                      //disabled={locationData !== null}
                      rows={4}
                      className="form-control"
                      style={{
                        width: "100%",
                        resize: "vertical",
                        minHeight: "100px",
                      }}
                    />
                    <ErrorMessage
                      name="rationaleJustification"
                      component="div"
                      className="text-danger extra-small mt-1"
                    />
                  </jnb.Form.Group>
                </jnb.Col>
              </jnb.Row>

              {clg === "degree" && (
                <jnb.Row className="mt-3 mb-3">
                  <jnb.Col xs={12} sm={6} md={6} lg={4} xl={4} xxl={4}>
                    <jnb.Form.Label className="small fw-bold text-dark">
                      Whether the new building is permanent and independent with
                      RCC roof
                      <span className="text-danger">*</span>
                    </jnb.Form.Label>
                    <Field
                      name="isPermanentRCC"
                      as="select"
                      className="form-control form-control-sm"
                    //disabled={locationData !== null}
                    >
                      <option value="">-- Select --</option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </Field>
                    <ErrorMessage
                      name="isPermanentRCC"
                      component="div"
                      className="text-danger extra-small"
                    />
                  </jnb.Col>

                  <jnb.Col xs={12} sm={6} md={6} lg={4} xl={4} xxl={4}>
                    <jnb.Form.Label className="small fw-bold text-dark">
                      Whether it is located at least 500 mtrs far away from
                      Cinema halls, wine shops, public function halls etc.
                      <span className="text-danger">*</span>
                    </jnb.Form.Label>
                    <Field
                      name="isDistance500m"
                      as="select"
                      className="form-control form-control-sm"
                    //disabled={locationData !== null}
                    >
                      <option value="">-- Select --</option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </Field>
                    <ErrorMessage
                      name="isDistance500m"
                      component="div"
                      className="text-danger extra-small"
                    />
                  </jnb.Col>
                  <jnb.Col xs={12} sm={6} md={6} lg={4} xl={4} xxl={4}>
                    <jnb.Form.Label className="small fw-bold text-dark">
                      Distance from the existing College Location to the
                      Proposed College Location (in KMs)
                      <span className="text-danger">*</span>
                    </jnb.Form.Label>
                    <Field
                      name="distanceFromExisting"
                      type="number"
                      step="0.01"
                      className="form-control form-control-sm"
                      placeholder="Enter distance in KMs"
                    //disabled={locationData !== null}
                    />
                    <ErrorMessage
                      name="distanceFromExisting"
                      component="div"
                      className="text-danger extra-small"
                    />
                  </jnb.Col>
                </jnb.Row>
              )}

              {/* 
              <div className="d-flex justify-content-end mt-4">
                <button className="btn btn-primary" type="submit">
                  Submit
                </button>
              </div> */}

              <div style={{ display: "flex", justifyContent: "flex-end", width: "100%" }}>



                {paymentDone?.paymentDone === true ? (
                  <div style={{ color: "green", fontWeight: "bold" }}>
                    ✅ Already submitted
                  </div>
                ) : (
                  <button
                    type="submit"
                    className="btn btn-success btn-sm"
                  >
                    Submit
                  </button>
                )}
              </div>

            </jnb.Card.Body>
          </jnb.Card>

          {/* Save Button */}

        </Form>
      </FormikProvider>

      <style>{`
                .modern-selector {
                    background: #ffffff;
                    border: 1px solid #dee2e6;
                    border-radius: 12px;
                    padding: 20px 15px;
                    text-align: center;
                    cursor: pointer;
                    transition: all 0.2s ease-in-out;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    height: 100%;
                }
                .modern-selector:hover {
                    border-color: #ced4da;
                    transform: translateY(-3px);
                    box-shadow: 0 4px 8px rgba(0,0,0,0.05);
                }
                .modern-selector.active {
                    background: #444444; 
                    border-color: #444444;
                    box-shadow: inset 0 2px 8px rgba(0,0,0,0.3);
                }
                .icon-container { font-size: 26px; margin-bottom: 12px; }
                .selector-title { font-size: 13px; font-weight: 700; color: #495057; line-height: 1.2; }
                .modern-selector.active .selector-title, 
                .modern-selector.active .extra-small { color: #ffffff !important; }
                
                .extra-small { font-size: 0.75rem; }
                .form-control:focus, .form-select:focus { border-color: #74b9ff; box-shadow: 0 0 0 0.2rem rgba(116, 185, 255, 0.25); }
            `}</style>
    </jnb.Container >
  );
};

export default ChangeOfLocationDtls;
